import { GET_FEEDBACK_QUESTIONS, GET_FEEDBACK_ANSWERS, GET_FEEDBACK_WAITERS, SEND_FEEDBACK_SUCCESS } from './../actions/types';

const initialState = {
    feedback_questions: [],
    feedback_answers: [],
    feedback_waiters: [],
    suggested_waiter_id: null,
}

export default function(state = initialState, action) {
    state.errors = [];

    switch(action.type) {
        case GET_FEEDBACK_QUESTIONS:
            return {
                ...state,
                feedback_questions: action.payload,
            }
        case GET_FEEDBACK_ANSWERS:
            return {
                ...state,
                feedback_answers: action.payload,
            }
        case GET_FEEDBACK_WAITERS:
            return {
                ...state,
                feedback_waiters: action.payload && action.payload.waiters ? action.payload.waiters : [],
                suggested_waiter_id: action.payload && action.payload.suggested_waiter_id ? action.payload.suggested_waiter_id : null,
            }
        case SEND_FEEDBACK_SUCCESS:
            return {
                ...state,
                message: "Благодаря за обратната връзка :)" //No translation needed
            }
        default:
            return state;
    }
}
